export const app = {
  title: 'Mirano system',
  logo: <img src="/assets/logo.svg" alt="" />,
};
